import script from "./CustomFieldsSettingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomFieldsSettingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomFieldsSettingsModal.vue?vue&type=style&index=0&id=178d4390&lang=scss&scoped=true"
import "./CustomFieldsSettingsModal.vue?vue&type=style&index=1&id=178d4390&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178d4390"]])

export default __exports__